const initialState = {
  id: null,
  picture: null,
  browser: null,
  roles: ["normal"], // Default role
  canSendMic: false,
  canSendWebcam: false,
  canShareScreen: false,
  canShareFiles: false,
  audioDevices: null,
  webcamDevices: null,
  webcamInProgress: false,
  audioInProgress: false,
  screenShareInProgress: false,
  displayNameInProgress: false,
  loginEnabled: false,
  raiseHand: false,
  raiseHandInProgress: false,
  loggedIn: false,
  nativeLanguage: "",
  visibility: true,
};

const me = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ME": {
      const { peerId, loginEnabled } = action.payload;

      return {
        ...state,
        id: peerId,
        loginEnabled,
      };
    }

    case "LOGGED_IN": {
      const { flag } = action.payload;

      return { ...state, loggedIn: flag };
    }

    case "ADD_ROLE": {
      if (state.roles.includes(action.payload.role)) return state;

      const roles = [...state.roles, action.payload.role];

      return { ...state, roles };
    }

    case "REMOVE_ROLE": {
      const roles = state.roles.filter((role) => role !== action.payload.role);

      return { ...state, roles };
    }

    case "SET_PICTURE":
      const { picture } = action.payload;

      return { ...state, picture: picture };

    case "SET_MEDIA_CAPABILITIES": {
      const {
        canSendMic,
        canSendWebcam,
        canShareScreen,
        canShareFiles,
      } = action.payload;

      return {
        ...state,
        canSendMic,
        canSendWebcam,
        canShareScreen,
        canShareFiles,
      };
    }

    case "SET_AUDIO_DEVICES": {
      const { devices } = action.payload;

      return { ...state, audioDevices: devices };
    }

    case "SET_AUDIO_OUTPUT_DEVICES": {
      const { devices } = action.payload;

      return { ...state, audioOutputDevices: devices };
    }

    case "SET_WEBCAM_DEVICES": {
      const { devices } = action.payload;

      return { ...state, webcamDevices: devices };
    }

    case "SET_AUDIO_IN_PROGRESS": {
      const { flag } = action.payload;

      return { ...state, audioInProgress: flag };
    }

    case "SET_WEBCAM_IN_PROGRESS": {
      const { flag } = action.payload;

      return { ...state, webcamInProgress: flag };
    }

    case "SET_SCREEN_SHARE_IN_PROGRESS": {
      const { flag } = action.payload;

      return { ...state, screenShareInProgress: flag };
    }

    case "SET_MY_RAISE_HAND_STATE": {
      const { flag, raiseHandIndex } = action.payload;

      return { ...state, raiseHand: flag, raiseHandIndex };
    }

    case "SET_MY_RAISE_HAND_STATE_IN_PROGRESS": {
      const { flag } = action.payload;

      return { ...state, raiseHandInProgress: flag };
    }

    case "SET_DISPLAY_NAME_IN_PROGRESS": {
      const { flag } = action.payload;

      return { ...state, displayNameInProgress: flag };
    }

    case "SET_BROWSER": {
      const { browser } = action.payload;

      return { ...state, browser };
    }

    case "SET_NATIVE_LANGUAGE": {
      const { nativeLanguage } = action.payload;

      return { ...state, nativeLanguage };
    }

    case "SET_VISIBILITY": {
      const { visibility } = action.payload;

      return { ...state, visibility };
    }
    default:
      return state;
  }
};

export default me;
